"use client";

import { Button } from "@/components/ui/button";
import { Share2 } from "lucide-react";
import ShareModal from "./share-modal";

interface ShareButtonProps {
  title: string;
  url?: string;
  description?: string;
  variant?: "default" | "outline" | "ghost";
  size?: "default" | "sm" | "lg" | "icon";
  className?: string;
  children?: React.ReactNode;
}

export default function ShareButton({
  title,
  url,
  description,
  variant = "outline",
  size = "default",
  className = "",
  children,
}: ShareButtonProps) {
  return (
    <ShareModal
      title={title}
      url={url}
      description={description}
    >
      <Button
        variant={variant}
        size={size}
        className={`flex items-center gap-2 ${className}`}
      >
        <Share2 className="h-4 w-4" />
        {children || "Share"}
      </Button>
    </ShareModal>
  );
}
